/**
 * ErrorBoundary Component
 * Catches JavaScript errors anywhere in the child component tree
 * Logs errors and displays a fallback UI
 */

import React from 'react';
import logger from '../utils/logger';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return {
      hasError: true,
      error
    };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to console in development or to external service in production
    logger.error('Error caught by ErrorBoundary:', {
      error: error.toString(),
      componentStack: errorInfo.componentStack
    });

    // Store error info in state
    this.setState({
      errorInfo
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="container mt-5">
          <div className="alert alert-danger text-center" role="alert">
            <div style={{ fontSize: '48px', marginBottom: '20px' }}>
              <i className="fas fa-exclamation-triangle"></i>
            </div>
            <h4>حدث خطأ غير متوقع</h4>
            <p>نعتذر عن الإزعاج. حدث خطأ أثناء تحميل الصفحة.</p>
            <p>يرجى تحديث الصفحة أو المحاولة لاحقاً.</p>

            {process.env.NODE_ENV === 'development' && this.state.error && (
              <details style={{ marginTop: '20px', textAlign: 'left' }}>
                <summary style={{ cursor: 'pointer', color: '#721c24' }}>
                  عرض تفاصيل الخطأ (Development Mode)
                </summary>
                <pre style={{
                  marginTop: '10px',
                  padding: '10px',
                  backgroundColor: '#f8d7da',
                  borderRadius: '4px',
                  fontSize: '12px',
                  overflow: 'auto'
                }}>
                  {this.state.error.toString()}
                  {this.state.errorInfo && this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}

            <div style={{ marginTop: '20px' }}>
              <button
                className="btn btn-primary"
                onClick={this.handleReload}
              >
                <i className="fas fa-sync-alt"></i> تحديث الصفحة
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
